import React,{ useRef, useState, useEffect } from "react"
import axios from "axios"
import Select from "react-select"
import jwt_decode from "jwt-decode"
import { useParams ,useNavigate } from "react-router-dom"
import { useDownloadExcel } from 'react-export-table-to-excel';
import { FormatRupiah } from "@arismun/format-rupiah"
import baseURL from "../../Url/Url.jsx"
import SideBar from "../../Layout/SideBar.jsx"
import PilihPeriode from "../../Layout/PilihPeriode.jsx"
import Pagination from "../../Layout/Pagination.jsx";

const MenuPerhitunganTidakTetap = () => {
    // variabel sistem utama
    const [userName, setUserName] = useState("")
    const [perusahaan, setPerusahaan] = useState("")
    const [estate, setEstate] = useState("")
    const [estateList, setEstateList] = useState([]);
    const [bulan, setBulan] = useState("Bulan")
    const [tahun, setTahun] = useState("Tahun")
    const [PerhitunganTidakTetap, setPerhitunganTidakTetap] = useState([])
    const [displayLoader, setDisplayLoader] = useState("none")
    const [search, setSearch] = useState('');
    const [msg, setMsg] = useState('');
    const [, setToken] = useState("")
    const [expire, setExpire] = useState("")
    const navigate = useNavigate()
    const tableRef = useRef(null);
    const { perusahaanParams } = useParams()
    const { bulanParams } = useParams()
    const { tahunParams } = useParams()

    // Sistem utama
    useEffect(()=>{
        refreshToken()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    
    useEffect(()=>{
        selectPerhitunganTidakTetap()
        // eslint-disable-next-line react-hooks/exhaustive-deps
        setCurrentPage(1); 
    
    }, [search, perusahaan, bulan, tahun]);
        
    useEffect(() => {
        const savedOption = localStorage.getItem("selectedOption");
        if (savedOption) {
            const [savedPerusahaan, savedEstate] = savedOption.split("|");
            setPerusahaan(savedPerusahaan);
            setEstate(savedEstate);
        }
    }, []);
    
    // Refresh token
    const refreshToken = async() => {
        try {
            const response = await axios.get(`${baseURL}/tokenBE`)
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setUserName(decoded.userName)
                        
            // cek cache dulu
            const savedOption = localStorage.getItem("selectedOption");
            if (savedOption) {
                const [savedPerusahaan, savedEstate] = savedOption.split("|");
                setPerusahaan(savedPerusahaan);
                setEstate(savedEstate);
            } else {
                setPerusahaan(decoded.perusahaan);
                setEstate(decoded.status);
            }
            
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)

            getEstateList(decoded.userName)
        } catch (error) {
            if(error.response){
                navigate("/", { replace: true })
            }   
        }
    }

    const axiosJWT = axios.create()
    axiosJWT.interceptors.request.use(async(config) => {
        const currentDate = new Date()
        if(expire * 1000 < currentDate.getTime()){
            const response = await axios.get(`${baseURL}/tokenBE`)
            config.headers.Authorization = `Bearer ${response.data.accessToken}`
            setToken(response.data.accessToken)
            const decoded = jwt_decode(response.data.accessToken)
            setPerusahaan(decoded.perusahaan)
            setBulan(decoded.bulan)
            setTahun(decoded.tahun)
            setExpire(decoded.exp)
        }
        return config
    }, (error)=>{
        return Promise.reject(error)
    })
    
    // Ambil daftar perusahaan + estate berdasarkan username
    const getEstateList = async (username) => {
        try {
            const response = await axios.post(
                `${baseURL}/selectPerusahaanByUserNameBE`,
                { userName: username }
            )
            setEstateList(response.data)
        } catch (error) {
            console.log("Gagal mengambil estate list:", error.response?.data || error.message)
            setEstateList([])
        }
    }
    const estateOptionsWithAll = [
        { value: `${perusahaan}|ALL`, label: "All" }, // Semua estate untuk perusahaan saat ini
        ...estateList.map((item) => ({
            value: `${item.perusahaan}|${item.status}`,
            label: `${item.status} | ${item.perusahaan}`
        }))
    ];

    // Logout
    const Logout = async() =>{
        try {
            await axios.delete(`${baseURL}/logoutBE`)
            navigate("/", { replace: true })
        } catch (error) {
            console.log(error)
        }
    }
    
    // Menyimpan perhitungan tidak tetap
    const createPerhitunganTidakTetap = async (e) => {
        e.preventDefault()
        try {
            setDisplayLoader("")
            if (window.confirm(`Apakah Anda yakin ingin Menghitung PPH ${estate} bulan ini?`))
            await axios.post(`${baseURL}/createPerhitunganTidakTetapBE`,{
                perusahaan: perusahaan,
                bulan: bulan,
                tahun: tahun,
                status: estate,
            })
            navigate(`/menu-perhitungan-karyawan-tidak-tetap/${perusahaan}/${bulan}/${tahun}`, { replace: true })
            window.location.reload()
        } catch (error) {
            if(error.response){
                setDisplayLoader("none")
                setMsg(error.response.data.msg)
                setTimeout(() => {
                    setMsg(""); // Mengosongkan kembali state msg
                }, 3000);
            }
        }
    }

    // Mengambil perhitungan tidak tetap
    const selectPerhitunganTidakTetap = async() =>{
        try {
            const query = search.trim() ? `?search=${encodeURIComponent(search)}` : '';
            const response = await axios.get(`${baseURL}/selectPerhitunganTidakTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}${query}`)
            setPerhitunganTidakTetap(response.data);
        } catch (error) {
            console.log("❌ Error axios.get:", error.response?.data || error.message);
        }
    }

    // Menghapus perhitungan tidak tetap
    const deletePerhitunganTidakTetap = async() => {
        try {
            await axios.delete(`${baseURL}/deletePerhitunganTidakTetapBE/${perusahaanParams}/${bulanParams}/${tahunParams}`, {
                data: { 
                    status: estate
                }
            })
            selectPerhitunganTidakTetap()
        } catch (error) {
            console.log(error)
        }
    }

    // Download ke excel
    const { onDownload } = useDownloadExcel({
        currentTableRef: tableRef.current,
        filename: `Data Perhitungan PPH Karyawan Tetap ${perusahaan} Estate ${estate} Bulan ${bulan} Tahun ${tahun}`,
        sheet: 'Users'
    })

    const filteredData = PerhitunganTidakTetap.filter((item) => {
        // Sesuai input pencarian
        const matchSearch =
            item.nama?.toLowerCase().includes(search.toLowerCase()) ||
            item.nik?.toLowerCase().includes(search.toLowerCase()) ||
            item.ktp?.toLowerCase().includes(search.toLowerCase())
        // Filter estate
        const matchPerusahaan = item.perusahaan?.toLowerCase() === perusahaan.toLowerCase();
        const matchEstate = estate === "ALL"
            ? estateList.some(
                (e) =>
                    e.perusahaan?.toLowerCase() === perusahaan.toLowerCase() &&
                    e.status?.toLowerCase() === item.unitKerja?.toLowerCase()
            )
            : item.unitKerja?.toLowerCase() === estate.toLowerCase();
        return matchSearch && matchEstate && matchPerusahaan;
    })

    // Pagination
    const [currentPage, setCurrentPage] = useState(1)
    const itemsPerPage = 200
    const handlePageChange = (page) => {
      setCurrentPage(page)
    }
    const startIndex = (currentPage - 1) * itemsPerPage
    const selectedData = filteredData.slice(startIndex, startIndex + itemsPerPage)

    // Halaman
    return (
        <div id="wrapper">

            {/* LOADER */}
            <div className="loader-page-bg" style={{display:displayLoader}}>
                <div className="loader-page"></div>
            </div>

            {/* SIDE BAR */}
            <SideBar 
                bulanParams={bulan}
                tahunParams={tahun}
                perusahaanParams={perusahaan}
                tahunSekarang={tahun}
            />

            {/* KONTEN WRAP */}
            <div id="content-wrapper">

                {/* NAVBAR */}
                <nav className="navbar navbar-expand-sm sticky-top nav-bar py-3">
                    <div className="container">
                        <div className="dropdown ml-2">
                            <button className="navbar-toggler mb-2" data-bs-toggle="collapse" data-bs-target="#sidebar" aria-controls="sidebar" aria-expanded="false" aria-label="Toggle navigation" style={{border:"none"}}>
                                <i className="bi bi-grid-fill" style={{fontSize:"22px"}}></i>
                            </button>
                        </div>
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0"></ul>
                        <div className="d-flex" role="search">
                            <input type="text" className="form-control form mx-2" placeholder="Cari Nama, NIK, KTP, dll" value={search} onChange={(e) => setSearch(e.target.value)}style={{marginTop:"-2px",color:"rgb(108, 108, 108)",maxWidth:"300px",fontSize:"10pt"}}/>
                            <Select
                                className="form-control form text-center mx-2"
                                value={estateOptionsWithAll.find(
                                    (opt) => opt.value === `${perusahaan}|${estate}`
                                )}
                                onChange={(selectedOption) => {
                                    const [selectedPerusahaan, selectedEstate] = selectedOption.value.split("|")
                                    setPerusahaan(selectedPerusahaan)
                                    setEstate(selectedEstate)
                                    setCurrentPage(1)
                                    // Simpan ke cache
                                    localStorage.setItem("selectedOption", selectedOption.value);
                                    // Reload halaman dengan params
                                    navigate(`/menu-perhitungan-karyawan-tidak-tetap/${selectedPerusahaan}/${bulan}/${tahun}`)
                                }}
                                options={estateOptionsWithAll}
                                isSearchable
                                styles={{
                                    container: (base) => ({
                                        ...base,
                                        marginTop: "-2px",
                                        maxWidth: "140px",
                                        fontWeight: "700",
                                        fontSize: "10pt",
                                        color:"rgb(108, 108, 108)",
                                        boxShadow: "none",  
                                        height: "auto",
                                        padding:"0",
                                    }),
                                    control: (base) => ({
                                        ...base,
                                        borderRadius:"30px",
                                        border:"none",
                                        background:"transparant",
                                        height: "10px",
                                        color:"rgb(108, 108, 108)",
                                        boxShadow: "none",  
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        width: "300px", // agar dropdown menyesuaikan lebar control
                                    })
                                }}
                            />
                            <input type="text" className="form-control form" value={perusahaan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"300px"}} readOnly/>
                            <input type="text" className="form-control form mx-2" value={bulan} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"120px",textAlign:"center"}} readOnly/>
                            <input type="text" className="form-control form" value={tahun} style={{marginTop:"-2px",color:"rgb(108, 108, 108)",fontWeight:"700",maxWidth:"70px",textAlign:"center"}} readOnly/>
                            <button onClick={Logout} className="btn btn-logout mx-2"><i className="bi bi-power" style={{color:"white",fontSize:"22px"}}></i></button>
                        </div>
                    </div>
                </nav>

                {/* KONTEN */}
                {bulan === "JANUARI" || bulan === "FEBRUARI" || bulan === "MARET"|| bulan === "APRIL"|| bulan === "MEI"|| bulan === "JUNI"|| bulan === "JULI"|| bulan === "AGUSTUS"|| bulan === "SEPTEMBER"|| bulan === "OKTOBER"|| bulan === "NOVEMBER"|| bulan === "DESEMBER"          
                ?<div>
                    <div className="container-fluid" style={{overflow:"auto",display:"block",width:"100%",height:"89vh"}}>
                        <h4 className="text-center my-3" style={{fontWeight:"700"}}>Menu Hitung PPH Karyawan Tidak Tetap</h4>
                        {msg && (
                            <div style={{ textAlign:"center", color: 'red', fontWeight: 'bold', marginBottom: '10px' }}>
                                {msg}
                            </div>
                        )}
                        <div className="row">
                            <div className="col-12">
                                <div className="box p-4 pb-2" style={{width: "100%"}}>
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-2 mb-3">
                                            <button className="btn excel-btn mx-auto d-block"title="Download Excel"onClick={onDownload}style={{ border: "none", backgroundColor: "white", marginTop: "-10px" }}><img src="/img/excel-export.png"alt="Excel"className="excel-icon"/></button>
                                        </div>
                                        <div className="col-12 col-md-5 mb-3 pt-3">
                                            <form onSubmit={createPerhitunganTidakTetap}>
                                                <input type="text" className="form-disable" value={perusahaan} readOnly/>
                                                <input type="text" className="form-disable" value={bulan} readOnly/>
                                                <input type="text" className="form-disable" value={tahun} readOnly/>
                                                <button type="submit" className="btn btn-login mx-auto w-100 d-block" style={{border:"none",backgroundColor:"white",marginTop:"-3px"}}><i className="bi bi-calculator"></i> Hitung PPH</button>
                                            </form>
                                        </div>
                                        <div className="col-12 col-md-5 mb-3 pt-3">
                                            <button className="btn btn-delete mx-auto w-100 d-block" onClick={() => {if (window.confirm(`Apakah Anda yakin ingin menghapus Semua data ${estate} bulan ini?`)) {deletePerhitunganTidakTetap();}}} style={{border:"none",backgroundColor:"red",marginTop:"-3px"}}><i className="bi bi-trash3"></i> Hapus Bln Ini</button>
                                        </div>
                                        <Pagination totalItems={PerhitunganTidakTetap.length}itemsPerPage={itemsPerPage}currentPage={currentPage}onPageChange={handlePageChange}/>
                                        <div style={{overflow:"auto",color:"rgb(108, 108, 108)",height:"61vh"}}>
                                            <table className="mb-3" style={{width:"1300px"}}>
                                                <thead>
                                                    <tr style={{fontWeight:"700",borderBottom:"1px solid rgb(108, 108, 108)"}}>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>No</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>Nama</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>NIK</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>KTP</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>NPWP</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>Status Kawin</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>Gaji Bruto</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>PPH Bulan Ini</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>Perusahaan</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>Bulan</td>
                                                        <td className="px-3 pb-2" style={{width:"auto"}}>Tahun</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedData.map((user,index)=>(
                                                        <tr key={index} style={{borderBottom:"1px solid rgb(108, 108, 108)"}}>
                                                            <td className="px-3" style={{width:"auto"}}>{index + 1}</td>
                                                            <td className="px-3 py-1" style={{width:"auto",textAlign:"left"}}>{user.nama}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.nik}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.ktp}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.npwp}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.statusKawin}</td>
                                                            <td className="px-3 py-1" style={{width:"auto",textAlign:"left"}}><FormatRupiah value={user.gajiBruto}/></td>
                                                            <td className="px-3 py-1" style={{width:"auto",textAlign:"left"}}><FormatRupiah value={user.pphBulanIni}/></td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.perusahaan}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.bulan}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.tahun}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                            <table ref={tableRef} style={{display:"none"}}>
                                                <thead>
                                                    <tr style={{fontWeight:"700"}}>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>No</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>Nama</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>NIK</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>KTP</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>NPWP</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>Status Kawin</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>Gaji Bruto</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>PPH Bulan Ini</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>Perusahaan</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>Bulan</td>
                                                        <td className="px-3 py-2" style={{width:"auto"}}>Tahun</td>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {filteredData.map((user,index)=>(
                                                        <tr key={index}>
                                                            <td className="px-3" style={{width:"auto"}}>{index + 1}</td>
                                                            <td className="px-3 py-1" style={{width:"auto",textAlign:"left"}}>{user.nama}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.nik}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.ktp}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.npwp}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.statusKawin}</td>
                                                            <td className="px-3 py-1" style={{width:"auto",textAlign:"left"}}>{user.gajiBruto}</td>
                                                            <td className="px-3 py-1" style={{width:"auto",textAlign:"left"}}>{user.pphBulanIni}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.perusahaan}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.bulan}</td>
                                                            <td className="px-3 py-1" style={{width:"auto"}}>{user.tahun}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                :<div>
                
                    {/* Pilih Periode */}
                    <PilihPeriode
                        bulan={bulan}
                        perusahaan={perusahaan}
                        tahunSekarang={tahun}
                    />

                </div>
                }

            </div>
        </div>
    )
}

export default MenuPerhitunganTidakTetap